import React, {Component} from 'react';
import {Row, Col, Form, InputGroup, Label, Button } from "reactstrap";
import {inject, observer} from "mobx-react";
import CalendarioPicker from '../../../comum/components/Calendario';
import FormInputSimples from '../../../comum/components/FormInputSimples';
import SelectFiltro from "../../../comum/components/SelectFiltro";
import { FecharFiltro, DocumentoCheck} from '../../../comum/components/Icones';
import Card from '../../../comum/components/Card';

import lscache from "lscache";
import FormDateTimePicker from './../../../comum/components/FormDateTimePicker';
import FormDatePicker from './../../../comum/components/FormDatePicker';
@inject("store")
@observer
export default class FiltrosAgendamento extends Component {
    constructor(props) {
        super(props);
        {/* TODO: inserir proptypes */}
        this.controller = this.props.controller;
        this.maisFiltros = lscache.get('agendamento-maisFiltros');
        this.state = { maisFiltros: this.maisFiltros ? this.maisFiltros : false,
                       filtrado: false };
        
        this.filtrosCompletos = this.filtrosCompletos.bind(this);
    }

    filtrar(){
        this.setState(state => ({filtrado: true}));
        this.controller.carregarLista();
    }

    componentDidMount() {
        this.checarFiltro();
    }

    checarFiltro() {
        
        lscache.flushExpired();

        if (lscache.get('agendamento-filtro')) 
        {
            (lscache.get('agendamento-tipoAgendId')) ? 
            this.controller.filtroSelecionado['tipoAgendId'] = lscache.get('agendamento-tipoAgendId') 
            : delete this.controller.filtroSelecionado['tipoAgendId'];

            (lscache.get('agendamento-dataInicial')) ? 
            this.controller.filtroSelecionado['dataInicial'] = lscache.get('agendamento-dataInicial') 
            : delete this.controller.filtroSelecionado['dataInicial'];
            
            (lscache.get('agendamento-dataFinal')) ? 
            this.controller.filtroSelecionado['dataFinal'] = lscache.get('agendamento-dataFinal') 
            : delete this.controller.filtroSelecionado['dataFinal'];
            
            (lscache.get('agendamento-tamanhoContainer')) ? 
            this.controller.filtroSelecionado['tamanhoContainer'] = lscache.get('agendamento-tamanhoContainer').value
            : delete this.controller.filtroSelecionado['tamanhoContainer'];
            
            (lscache.get('agendamento-transp')) ? 
            this.controller.filtroSelecionado['transpId'] = lscache.get('agendamento-transp').value
            : delete this.controller.filtroSelecionado['transpId'];
          
            (lscache.get('agendamento-VesselvisitId')) ? 
            this.controller.filtroSelecionado['VesselvisitId'] = lscache.get('agendamento-VesselvisitId') 
            : delete this.controller.filtroSelecionado['VesselvisitId'];
            
            (lscache.get('agendamento-status')) ? 
            this.controller.filtroSelecionado['status'] = lscache.get('agendamento-status') 
            : delete this.controller.filtroSelecionado['status'];
            
            (lscache.get('agendamento-container')) ? 
            this.controller.filtroSelecionado['container'] = lscache.get('agendamento-container') 
            : delete this.controller.filtroSelecionado['container'];

            (lscache.get('agendamento-placa')) ? 
            this.controller.filtroSelecionado['placa'] = lscache.get('agendamento-placa') 
            : delete this.controller.filtroSelecionado['placa'];

            (lscache.get('agendamento-cnh')) ? 
            this.controller.filtroSelecionado['cnh'] = lscache.get('agendamento-cnh') 
            : delete this.controller.filtroSelecionado['cnh'];

            (lscache.get('agendamento-booking')) ? 
            this.controller.filtroSelecionado['booking'] = lscache.get('agendamento-booking') 
            : delete this.controller.filtroSelecionado['booking'];

            (lscache.get('agendamento-dat')) ? 
            this.controller.filtroSelecionado['dat'] = lscache.get('agendamento-dat') 
            : delete this.controller.filtroSelecionado['dat'];

            this.controller.filtraDataCache = true;
            this.filtrar()
        }
        
    }

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };
    
    filtrosCompletos = () => {
        let xl=3;let lg=6; let md=4; let sm=6; let xs=12;
        return <React.Fragment>
                <Row className="align-items-end">
                    <SelectFiltro titulo="Tipo" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                    itens={this.controller.tiposAgendamento}
                                    valor={this.controller.tiposPreenchido}
                                    itensValor="Id" itensLabel="DscTipo"
                                    onChange={this.controller.setTipo} />

                    <SelectFiltro titulo="Operação" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                    bloqueado={!this.controller.tiposPreenchido}
                                    itens={this.controller.operacoes}
                                    valor={this.controller.operacoesPreenchido}
                                    itensValor="Viagem" itensLabel="IdViagemDtPrev"
                                    onChange={this.controller.setOperacao}/>

                    <SelectFiltro titulo="Status" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                    itens={this.controller.status}
                                    valor={this.controller.statusPreenchido}
                                    itensValor="Codigo" itensLabel="Descricao"
                                    onChange={this.controller.setStatus}/>
                   
                    <FormInputSimples titulo="CNTR" xl={xl} md={md} sm={sm} xs={xs} uppercase={true} onEnter={() => this.filtrar()}
                                      dado={this.controller.container}
                                      onChange={(event) => this.controller.setContainer(event.target.value)}
                                      onBlur={(event) => this.controller.setContainer(event.target.value)}
                                      
                    />

                    <SelectFiltro titulo="Tamanho Container" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                    itens={this.controller.tamanhos}
                                    valor={this.controller.tamanhoContainer}
                                    itensValor="Codigo" itensLabel="Descr"
                                    onChange={this.controller.setTamanhoContainer}/>

                    {process.env.ssa && <SelectFiltro titulo="Transportadora" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                    itens={this.controller.transportadoras}
                                    valor={this.controller.transportadora}
                                    itensValor="TranspId" itensLabel="ApelidoTransp"
                                    onChange={this.controller.setTransportadora}/>}

                    <Col xl={xl} md={md} sm={sm} xs={xs} className="mb-4">
                        <div className="w-100">
                            <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                                    <FormDatePicker titulo="Data Início" xs={12} sm={12} md={12} lg={12} xl={12}
                                        date={this.controller.dataInicial} 
                                        onChange={(value)=>this.controller.onChangeDataInicio(value)}
                                        //alerta={}
                                    />
                            </InputGroup>
                        </div>
                    </Col>
                    <Col xl={xl} md={md} sm={sm} xs={xs} className="mb-4">
                        <div className="w-100">
                            <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                                    <FormDatePicker titulo="Data Fim" xs={12} sm={12} md={12} lg={12} xl={12}
                                        date={this.controller.dataFinal} 
                                        onChange={(value)=>this.controller.onChangeDataFim(value)}
                                    />
                            </InputGroup>
                        </div>
                    </Col>
                    
                   
                   <FormInputSimples titulo="Placa" xl={xl} md={md} sm={sm} xs={xs} uppercase={true}  onEnter={() => this.filtrar()}
                                      dado={this.controller.placa}
                                      onChange={(event) => this.controller.setPlaca(event.target.value)}
                                      onBlur={(event) => this.controller.setPlaca(event.target.value)}
                    />

                    
                    <FormInputSimples titulo="CNH" xl={xl} md={md} sm={sm} xs={xs}  onEnter={() => this.filtrar()}
                                      dado={this.controller.cnh}
                                      onChange={(event) => this.controller.setCnh(event.target.value)}
                                      onBlur={(event) => this.controller.setCnh(event.target.value)}
                    />
                    
                    <FormInputSimples titulo="Booking" xl={xl} md={md} sm={sm} xs={xs} uppercase={true}  onEnter={() => this.filtrar()}
                                      dado={this.controller.booking}
                                      onChange={(event) => this.controller.setBooking(event.target.value)}
                                      onBlur={(event) => this.controller.setBooking(event.target.value)}
                    />

                    {lscache.get('InternoExterno') === 'I' && (<SelectFiltro titulo="DAT" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
                                      itens={this.controller.StatusDAT}
                                      valor={this.controller.datPreenchido}
                                      itensValor="Codigo" itensLabel="Descricao"
                                      onChange={this.controller.setDAT}/>)}

                    <Col sm={sm} xs={xs} className="mb-4 align-bottom">
                        <Button className="btn-filtros ativo" onClick={ () => this.mudaFiltros() } outline>
                            <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
                            Menos filtros
                        </Button>
                        <Button className="ml-1 btn-filtros" onClick={ () => this.controller.limparFiltros() } outline>
                            Limpar filtros
                        </Button>
                        <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()} >Filtrar</Button>
                        
                    </Col>
                </Row>
            </React.Fragment>
    };
    
    filtrosBasicos = () => {
        let camposXl = 3;
        return <React.Fragment>
                    <Row className="align-items-end">
                    
                    <SelectFiltro titulo="Tipo" xl={camposXl} md={4} sm={6} xs={12}
                                        itens={this.controller.tiposAgendamento}
                                        valor={this.controller.tiposPreenchido}
                                        itensValor="Id" itensLabel="DscTipo"
                                        onChange={this.controller.setTipo} />
                    
                    {/* <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                            <div className="w-100">
                                <Col xs={12} className="col-label px-0">
                                    <Label>Período</Label>
                                </Col>

                                <Col xs={12} className="px-0">
                                    <InputGroup className={this.controller.seletorPeriodo ? 'ativo' : ''}>
                                        <CalendarioPicker visivel={this.controller.seletorPeriodo}
                                                            onChangeInicio={valor => this.controller.onChangeDataInicio(valor)}
                                                            onChangeFim={valor => this.controller.onChangeDataFim(valor)}
                                                            dataInicial={this.controller.dataInicial}
                                                            dataFinal={this.controller.dataFinal}
                                                            fechar={this.controller.toggleDataSeletor}
                                                            filtrar={() => {}}/>    
                                    </InputGroup>

                                </Col>
                            </div>
                        </Col> */}
                        <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                            <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                                    <FormDatePicker titulo="Data Início" xs={12} sm={12} md={12} lg={12} xl={12}
                                        date={this.controller.dataInicial} 
                                        onChange={(value)=>this.controller.onChangeDataInicio(value)}
                                    />
                            </InputGroup>
                        </Col>
                        <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                            <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                                    <FormDatePicker titulo="Data Fim" xs={12} sm={12} md={12} lg={12} xl={12}
                                        date={this.controller.dataFinal} 
                                        onChange={(value)=>this.controller.onChangeDataFim(value)}
                                    />
                            </InputGroup>
                        </Col>
                        <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                            <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                                <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
                                Mais filtros
                            </Button>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()} >Filtrar</Button>
                        </Col>
                    </Row>
    </React.Fragment>
    };

    mudaFiltros = () => {
        this.setMaisFiltros(!this.state.maisFiltros);
        this.setState({maisFiltros: !this.state.maisFiltros});
    };

    setMaisFiltros (bool) {
        lscache.set('agendamento-maisFiltros', bool, 5);
    }

    renderDados = () => {
        return(
             <Card className="mb-0">
                <div className="filtros agendamento m-0 p-0">
                   {this.filtros()}     
                </div>
            </Card>
        )
    }

    render() {
        return <React.Fragment>
                    {this.controller.atualizaFiltro && this.renderDados()}
                </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/components/FiltrosAgendamento.js